import React from 'react';

interface ToggleProps {
  on: boolean;
  onChange: () => void;
  ariaLabel?: string;
}

/** Pink on/off toggle matching the design's `.toggle` styling. */
const Toggle: React.FC<ToggleProps> = ({ on, onChange, ariaLabel }) => (
  <button
    type="button"
    onClick={(e) => {
      e.stopPropagation();
      onChange();
    }}
    aria-label={ariaLabel}
    aria-pressed={on}
    style={{
      width: 48,
      height: 26,
      borderRadius: 13,
      border: 'none',
      padding: 0,
      position: 'relative',
      cursor: 'pointer',
      flexShrink: 0,
      transition: 'background .2s ease',
      background: on ? 'var(--brand)' : 'var(--g300)',
    }}
  >
    <span
      style={{
        position: 'absolute',
        top: 3,
        left: on ? 25 : 3,
        width: 20,
        height: 20,
        borderRadius: '50%',
        background: '#fff',
        transition: 'left .2s ease',
        boxShadow: '0 1px 3px rgba(0,0,0,.2)',
      }}
    />
  </button>
);

export default Toggle;
